export default "__VITE_PUBLIC_ASSET__d08dd869__"